<div class="notice notice-success" [class.show]="show$$.value">
  <div class="left-bar"></div>
  <div class="notice-text"><b>Success!&nbsp;</b> <span [innerHTML]="text | safeHtml"></span></div>
  <i class="pi pi-times rs-pi-icon-sized c-p p-20" (click)="handleClose()"></i>
</div>
